module.exports = __webpack_public_path__ + "static/media/form.48dd2df4.jpeg";